<app-modal [title]="esDirectTransfer ? 'ID de la pajuela' : 'Marca OPS de la pajuela'" [loading]="loadingCombos">
  <p class="mb-4 text-sm text-gray-500 dark:text-gray-400">
    Pajuela #{{ pajuela.orden }} · {{ pajuela.nro_embriones }} embrión(es)
  </p>

  <app-form [formGroup]="saveForm">
    <!-- Issue #19 (2026-09-15): la pajuela Direct Transfer viene rotulada de
         fábrica; se corrige ese ID y no la marca OPS. -->
    @if (esDirectTransfer) {
      <div class="mb-5">
        <app-label for="identificador">
          ID de la pajuela
        </app-label>
        <app-input-field id="identificador" formControlName="identificador" placeholder="ID impreso en la pajuela" />
      </div>
    } @else {
      <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
        <div>
          <app-label for="param_ops_punto_id">
            Punto de OPS
          </app-label>
          <app-select id="param_ops_punto_id" formControlName="param_ops_punto_id" placeholder="Seleccione un punto" [options]="puntosOptions" />
        </div>

        <div>
          <app-label for="param_ops_color_id">
            Color de OPS
          </app-label>
          <app-select id="param_ops_color_id" formControlName="param_ops_color_id" placeholder="Seleccione un color" [options]="coloresOptions" />
        </div>
      </div>
    }

    <p class="mb-5 text-sm text-gray-600 dark:text-gray-300">
      {{ esDirectTransfer ? 'Identificación' : 'Marca OPS' }}: <span class="font-medium text-gray-800 dark:text-white">{{ etiquetaPrevia || '—' }}</span>
    </p>
  </app-form>

  <app-creation-buttons
    [valid]="saveForm.valid"
    [process]="loading"
    (onCreateClick)="save()"
    (onCancelClick)="cancel()"
  />
</app-modal>
